<script lang="ts">
  import type { CommentAttachment } from "../../comments/CommentTypes";
  import LinkAttachment from "./LinkAttachment.svelte";
  import ImageAttachment from "./ImageAttachment.svelte";
  import VideoAttachment from "./VideoAttachment.svelte";
  import GameAttachment from "./GameAttachment.svelte";

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false

  const componentTypes = {
    'link': LinkAttachment,
    'image': ImageAttachment,
    'video': VideoAttachment,
    'game': GameAttachment
  }

  if (!Object.keys(componentTypes).includes(attachment.type)) {
    attachment.type = 'link'
  }
</script>

<svelte:component this={componentTypes[attachment.type]} attachment={attachment} onlyAttachment={onlyAttachment}/>
